import * as React from 'react';
import { formatRelativeDate } from 'owa-observable-datetime';
import { observer } from 'mobx-react';

export interface MailListItemTimeStampProps {
    className: string;
    timeString: string;
}

@observer
export class MailListItemTimeStamp extends React.Component<MailListItemTimeStampProps, {}> {
    render() {
        const { className, timeString } = this.props;

        // VSO #41046: In rare cases the time here which comes directly from the conversation item via server response is undefined
        if (!timeString) {
            return null;
        }

        return <time className={className}>{formatRelativeDate(timeString)}</time>;
    }
}
